import ChangePasswordButton from "@husky-hrc/Components/ChangePasswordButton";
import { ProfilePageContext } from "@husky-hrc/Pages/ProfilePage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface ChangePasswordStyles {
    wrapperStyles: InjectableCss;
    passwordTitle: TypographyProps;
    buttonStyles: ButtonPresentationProps;
}

interface OwnProps extends WidgetProps {
    styles?: ChangePasswordStyles;
}

export const changePasswordStyles: ChangePasswordStyles = {
    wrapperStyles: {
        css: css`
            display: flex;
            align-items: center;
            margin-left: 10px;
        `,
    },
    passwordTitle: {
        css: css`
            font-size: 16px;
            text-transform: uppercase;
            font-weight: 800;
            letter-spacing: 1.78px;
            display: block;
            padding: 10px 0 10px 10px;
            background: #f6f5fb;
        `,
    },
    buttonStyles: {
        css: css`
            font-size: 16px;
            letter-spacing: 0.2px;
            color: black;
            margin-right: 30px;
            min-width: 291px;
            max-width: 64px;
            margin-top: 20px;
            height: 64px;
            border-radius: 4px;
        `,
    },
};

const styles = changePasswordStyles;
const changePasswordButtonText = "Change Password";
const variantType = "primary";

type Props = OwnProps;

const ChangePassword: React.FC<Props> = () => {
    return (
        <>
            <Typography {...styles.passwordTitle}>Password</Typography>
            <br />
            <ChangePasswordButton
                extendedStyles={styles.buttonStyles}
                buttonText={changePasswordButtonText}
                variant={variantType}
            ></ChangePasswordButton>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ChangePassword,
    definition: {
        displayName: "Change Password",
        group: "Addresses",
        allowedContexts: ["ProfilePage"] as any,
    },
};

export default widgetModule;
